import color from "../../../constants/color";

const style = {
  container: {
    height: "84%",
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    margin: '20px',
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: 3.5
  },
  field: {
    width: '100%',
    "& .MuiFormControl-root": {
      width: '100%',
      borderRadius: '8px !important'
    },
    '& .MuiTypography-root': {
      fontSize: '14px',
      color: '#202020',
      fontWeight: 500,
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff',
      '& fieldset': {
        borderColor: '#E0E0E0',
      },
      '&:hover fieldset': {
        borderColor: '#28AA4A',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#28AA4A',
      },
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
      color: '#202020',
      '&::placeholder': {
        color: '#878787',
        opacity: 1,
      },
    },
  },
  formSection: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    marginBottom: '24px',
  },
  textField: {
    height: '41px',
    borderRadius: '8px',
    '& fieldset': {
      border: '1px solid #D9D9D9',
      borderRadius: '8px',
    },
    '&:hover fieldset': {
      borderColor: '#D9D9D9',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#28AA4A',
    },
    '& .MuiInputBase-input': {
      padding: '10px 15px',
      fontSize: '14px',
    },
  },
  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
  },
  jobButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "12px",
    mt: 1,
  },
  dropDownMenu: {
    fontSize: "14px",
    fontWeight: "400",
  },

  gridbioBox: {
    backgroundColor: "#ffff",
    m: 3,
    p: 3,
    mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },
  inputSection: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    px: 2
  },


  leaveSection: {
    px: 2
  },
  inputLabel: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text
  },
  inputContainer: {
    // width:{xs:"18em",md:"25em",},
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  modalInput: {
    display: "flex",    // backgroundColor:color.lightGray,
    borderRadius: "30px",
    // width:{ xs: "25em", md: "35em" },
    justifyContent: "center",// Center align on smaller screens
    my: "10px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "5.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0"
    },
    width: "100%"
  },


  uploadSection: {
    px: 2,
    width: { xs: "100%", md: "55%" },

    "& .css-2y07vr": {
      py: "7px"

    }
  },
  leaveInputGrid: {
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    justifyContent: "space-between"

  },
  leaveSheetGrid: {
    display: { xs: "block", md: "flex" },
    ml: { xs: 0, md: 2 },
    mt: { xs: 0, md: 2 },
    height: "fit-content"
  },
  leaveSheet: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "5px",
    px: 1,
    mr: 1,
    mb: { xs: 1, md: 0 },
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    " & .css-0": {
      display: "flex",

    },
  },
  closeIcon: {
    fontSize: "1rem",
    ml: 2,
  },

  inputBox: {
    width: { xs: "100%", md: "49%", lg: "31%" }
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    marginBottom: '8px',
  },
  errorField: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red !important',
      borderWidth: '2px !important',
    },
  },
  errorText: {
    color: 'red !important',
    fontSize: '0.875rem !important',
    mt: 1,
  },
  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  uploadText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
    mt: 2,
    mb: 1,

  },
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 2,
    px: 2,
    mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },
  gridText: {
    mx: 2,
    fontSize: "14px",
    fontWeight: "600"
  },
  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display: "flex",
    flexDirection: "row",
    // justifyContent:"space-Between"
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    m: "10px",
    px: "10px",
    display: "flex",
    mb: 2,
    // gap: 2,
    justifyContent: "flex-end",
  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "-8px",
    },

  },
  cancelButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#878787",
    fontSize: "14px",
    fontWeight: "500",
    ml: 3,
    px: 4,

  },
  switchKeyText: {
    width: { xs: "60%", md: "32%" }
  },
  switchContent: {
    fontSize: "12px",
    fontWeight: "500",
  },
  descText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color?.text,
  },
  descValueText: {
    fontSize: "14px",
    fontWeight: "500",
    color: color?.text,
  },
  infoSection: {
    px: 3,
  },
  bioIconText: {
    fontSize: "22px",
    fontWeight: "600",
  },
  textPrimary: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
  },
  line: {
    border: "1px solid #D9D9D9",
    my: 2,
    mx: 3
  },
  subHeading: {
    fontSize: "16px",
    fontWeight: "600"
  },
  contactSection: {
    mt: 4,
  },

  contenttSection: {
    mt: 2.5,
  },

  durationText: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "21px",

  },
  contactSubheading: {
    fontSize: "18px",
    fontWeight: "600",

  },
  infoBox: {
    display: "flex",
    mb: 1.5,
  },
  bioText: {
    fontSize: "14px",
    fontWeight: "600",
  },
  bioTextValue: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,

  },
  bioTextValueSuccess: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,
    color: color.primary,

  },
  detailText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.text
  },
  closeJob: {
    color: "#FF0000",
    fontSize: "14px",
  },
  removeSection: {
    display: "flex",
    alignItem: "center",
    justifyContent: "space-between",
    mt: 2,

  },
  liText: {
    fontSize: "14px",
    listStyle: "disc !important",
    display: "list-item",
  },
  createJob: {
    textAlign: "center",
  },
  countryCode: {
    ".react-tel-input": {
      width: "100%",
      "& .selected-flag": {
        "& .flag": {
          mt: "-9px",
        },
      },
    },
  },
  switchBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  addressBox: {
    display: "flex",
    justifyContent: "space-between",
    gap: "3%",
    padding: '20px 20px 0px 20px'
  },
  addressInput: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    my: 3
  },
  addressTextField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
      fontWeight: 400,
    },
  },
};

export default style;